import * as Yup from 'yup';

import { getInstallmentsTotal } from 'helpers/serviceProviderBilling';

const emptyToUndefined = (value: unknown, originalValue: unknown) =>
    originalValue === '' ? undefined : value;

const hasUniqueStatuses = (installments: { statuses?: string[] }[] | undefined): boolean => {
    const statuses = (installments ?? []).flatMap((installment) => installment.statuses ?? []);
    return new Set(statuses).size === statuses.length;
};

export const billingRuleValidationSchema = (translate: (key: string) => string) =>
    Yup.object({
        price: Yup.number()
            .transform(emptyToUndefined)
            .typeError(translate('serviceProviderBilling.validation.price'))
            .positive(translate('serviceProviderBilling.validation.price'))
            .required(translate('required')),
        currency: Yup.string().required(translate('required')),
        installments: Yup.array()
            .of(
                Yup.object({
                    statuses: Yup.array()
                        .of(Yup.string().required())
                        .min(1, translate('serviceProviderBilling.validation.statuses')),
                    percentage: Yup.number()
                        .transform(emptyToUndefined)
                        .typeError(translate('serviceProviderBilling.validation.percentage'))
                        .moreThan(0, translate('serviceProviderBilling.validation.percentage'))
                        .max(100, translate('serviceProviderBilling.validation.percentage'))
                        .required(translate('required')),
                })
            )
            .min(1, translate('serviceProviderBilling.validation.installments'))
            .test(
                'installments-total',
                translate('serviceProviderBilling.validation.total'),
                (installments) => getInstallmentsTotal(installments ?? []) === 100
            )
            .test(
                'unique-statuses',
                translate('serviceProviderBilling.validation.uniqueStatuses'),
                hasUniqueStatuses
            )
            .required(),
    });

export const assessmentBillingValidationSchema = (translate: (key: string) => string) =>
    Yup.object({
        price: Yup.number()
            .transform(emptyToUndefined)
            .typeError(translate('serviceProviderBilling.validation.price'))
            .positive(translate('serviceProviderBilling.validation.price'))
            .required(translate('required')),
        currency: Yup.string().required(translate('required')),
    });
